export default "__VITE_ASSET__DHlqjDID__"